import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import GroupImageRepository from '@/shared/http/repositories/realestate/groupimage'
import GroupImageArquivoRepository from '@/shared/http/repositories/realestate/groupimagearquivo'
import CollapseImageDocumets from './components/collapseimagedocumets.vue'
import { loading } from '@/shared/utils/UIHelper'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export default {
  name: 'documentoccourences',
  props: ['detailsoccourence', 'statusOcorencia'],
  components: {HeadDetailsGama, CollapseImageDocumets},
  data () {
    return {
      newNameGroup: '',
      dataallgroup: [],
      searchFile: '',
      datafilefilter: [],
      ispdf: false,
      imgDetails: {},
      flDisable: false
    }
  },
  watch: {
    searchFile (newvalue) {
      let data = []
      this.dataallgroup.forEach((Element) => {
        Element.reGroupImageArquivos.forEach((Element) => data.push(Element))
      })
      this.datafilefilter = data.filter((Element) => Element.descricao.includes(newvalue))
    },
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 3 || newvalue < 0
    }
  },
  mounted () {
    this.GetAllByOccourenceId()
    this.flDisable = this.statusOcorencia >= 3 || this.statusOcorencia < 0
  },
  methods: {
    openmodalnewFile () {
      this.$refs['modalnewFile'].show()
    },
    closepoupmodalnewFile () {
      this.$refs['modalnewgroup'].show()
    },
    onDragOver (id) {
      let drop = document.getElementById('drop-' + id)
      if (drop !== null && drop !== undefined) {
        drop.style.background = '#a9a5a5'
      }
    },
    onDragLeave (id) {
      let drop = document.getElementById('drop-' + id)
      if (drop !== null && drop !== undefined) {
        drop.style.background = ''
      }
    },
    openinputfile () {
      let file = document.querySelector('.file-hidden')
      if (file !== null && file !== undefined) file.click()
    },
    SendImage (e) {
    },
    openmodalnewgroup () {
      this.newNameGroup = ''
      this.$refs['modalnewgroup'].show()
    },
    closemodalnewgroup () {
      this.$refs['modalnewgroup'].hide()
    },
    SaveGroup () {
      let data = {
        occurenceId: this.detailsoccourence.id,
        nome: this.newNameGroup
      }
      loading.push()
      GroupImageRepository.SaveGroup(data)
        .then((Response) => {
          this.closemodalnewgroup()
          loading.pop()
          this.GetAllByOccourenceId()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    RemoveImgArquivoGroup (id) {
      loading.push()
      GroupImageArquivoRepository.RemoveImgArquivoGroup(id)
        .then((Response) => {
          this.GetAllByOccourenceId()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    imageDetails (obj, ispdf) {
      this.imgDetails = obj
      this.ispdf = ispdf
      this.$refs.modalDetails.show()
    },
    openinputfilegroup (id) {
      let input = document.getElementById('file-' + id)
      if (input !== null && input !== undefined) input.click()
    },
    GetAllByOccourenceId () {
      loading.push()
      GroupImageRepository.GetAllByOccourenceId(this.detailsoccourence.id)
        .then((Response) => {
          this.dataallgroup = Response.data
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    downloadGroup  () {
      var zip = new JSZip()
      this.dataallgroup.forEach((Element) => {
        let input = document.getElementById('check-' + Element.id)
        if (input !== null && input !== undefined) {
          if (input.checked) {
            let img = zip.folder(input.nome)
            Element.reGroupImageArquivos.forEach((Element) => {
              img.file(Element.descricao, Element.arquivo, {base64: true, createFolders: true})
            })
          }
        }
      })
      zip.generateAsync({
        type: 'blob'
      }).then(function (content) {
        saveAs(content, 'midias.zip')
      })
    },
    SendFileArquivo (e) {
      loading.push()
      let data = new FormData()
      const isDrop = e.dataTransfer !== undefined && e.dataTransfer !== null
      const fileList = isDrop ? e.dataTransfer.files : e.target.files

      if (!fileList || fileList.length === 0) {
        loading.pop()
        return
      }

      Array.from(fileList).forEach((Element) => {
        data.append('file', Element)
      })

      const ownerEl = isDrop
        ? (e.currentTarget || e.target.closest('[id^="drop-"]'))
        : e.target
      const groupId = ((ownerEl && ownerEl.id) || '').replace('file-', '').replace('drop-', '')

      if (!groupId) {
        loading.pop()
        return
      }

      this.onDragLeave(groupId)
      GroupImageRepository.SendFileArquivo(groupId, data)
        .then((Response) => {
          this.GetAllByOccourenceId()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/documentoccourences/documentoccourences.js